import { SM } from '../assets/data/enum/storeModel.enum';
import { productionBase } from './base/production.base';
import { SAASBRANDNAME } from '../assets/data/enum/saasBrandName.enum';

export const environment = {
  ...productionBase,
  themeConfig: {
    ...productionBase.themeConfig,
    brand: 'viti',
    environmentName: 'viti-prod',
    textName: 'SpecialtyOps™',
    indexPage: '/auth/map',
    store: false,
    survey: false,
    badgePRO: false,
    welcomeUserCheck: false,
    welcomeFarmCheck: false,
    showYaraNPK: false,
    storewebAppUrl: 'https://vitipartnership.myplmconnect.com/sso/auth',
    termsAndCondition: 'https://legal.xfarm.ag/#/terms-and-conditions?l=it&v=latest&b=viti',
    privacyPolicy: 'https://legal.xfarm.ag/#/privacy-policy?l=it&v=latest&b=viti',
    enableForgotPassword: false,
    enableRegistration: false,
    enableLoginForm: false,
    enableSloganLogin: false,
    advEnable: false,
    forceHideFunctionalityList: [
      SM.SM_ANALYTICS_SUSTAINABILITY,
      SM.SM_ANALYTICS_OVERVIEW,
      SM.SM_ANALYTICS_CHAIN_MANAGEMENT,
      SM.SM_CONTRACT_MANAGEMENT,
      SM.SM_CONTRACT_AUDIT,
      SM.SM_GUIDE,
      SM.SM_EDUCATION_EDITOR,
      SM.SM_CROP_MAP,
      SM.SM_DASHBOARD,
      SM.SM_NUTRITION_FREE,
      SM.SM_WAREHOUSE,
      SM.SM_PRODUCT,
      SM.SM_LOAD,
      SM.SM_STABLE_LOAD,
      SM.SM_SILOS,
      SM.SM_CROP_PLANNING,
      SM.SM_BATCH,
      SM.SM_SATELLITE_FREE,
      SM.SM_ALERT,
      SM.SM_FINANCE,
      SM.SM_ANALYTICS_OVERVIEW,
      SM.SM_ANALYTICS_CHAIN_MANAGEMENT,
      SM.SM_ANALYTICS_SUSTAINABILITY,
      SM.SM_OPERATION_MANAGEMENT,
      SM.SM_FARM_DOSSIER,
      SM.SM_SUSTAINABILITY,
      SM.SM_CHECKS,
      SM.SM_RATIONS,
      SM.SM_EDUCATION_EDITOR,
      SM.SM_SURVEY,
      SM.SM_INCABCLOUD_TELEMETRY,
    ],
    availableLanguages: ['fr', 'en', 'it', 'es', 'pt', 'de', 'nl'],
    newsSidebarTabActivation: false,
    forcedDefaultLang: 'fr',
    hideMultifarmSelector: false,
    alertPushSelectionEnable: false,
    enableUserManagement: false,
    activeSocial: [SAASBRANDNAME.VITI],
    sideBarItemsOverride: {
      '/auth/map': { order: 0 },
      '/auth/fields': { order: 1 },
      '/auth/activities': { order: 2 },
      '/auth/task-plan': { order: 3 },
      '/auth/weather': { order: 4 },
      '/auth/equipments': { order: 5 },
      '/auth/satellite/manage-files': { order: 6 },
      '/auth/sensors': { order: 7 },
      '/auth/notes': { order: 8 },
      '/auth/task-viewer': { order: 9 },
      '/auth/irrigation': { order: 10, label: 'navbar.viti_irrigating', forceProEnabled: false },
      '/auth/diseases': { order: 11, label: 'navbar.viti_defence' },
      '/auth/insects': { order: 12 },
      '/auth/import-export/export': { order: 13 },
    },
  },
  local: false,
  production: false,
  enableScanDOMMode: false,
  palette: {
    '--p-xFarm-primary-50': '#94b1fa',
    '--p-xFarm-primary-100': '#b8cdf5',
    '--p-xFarm-primary-200': '#7fa8eb',
    '--p-xFarm-primary-300': '#5c87d6',
    '--p-xFarm-primary-400': '#00205B',
    '--p-xFarm-primary-500': '#1e579b', // era primary50
    '--p-xFarm-primary-600': '#18467d',
    '--p-xFarm-primary-700': '#133560',
    '--p-xFarm-primary-800': '#0e2543',
    '--p-xFarm-primary-900': '#091527',
    '--p-xFarm-primary-950': '#00153b', // era primary110    '--p-xFarm-primary-50': '#94b1fa',
    '--p-xfarm-50': '#94b1fa',
    '--p-xfarm-100': '#b8cdf5',
    '--p-xfarm-200': '#7fa8eb',
    '--p-xfarm-300': '#5c87d6',
    '--p-xfarm-400': '#00205B',
    '--p-xfarm-500': '#1e579b', // era primary50
    '--p-xfarm-600': '#18467d',
    '--p-xfarm-700': '#133560',
    '--p-xfarm-800': '#0e2543',
    '--p-xfarm-900': '#091527',
    '--p-xfarm-950': '#00153b', // era primary110,
    '--p-xfarm-chart-light': '#343e5b',
    '--p-xfarm-chart-dark': '#337ab7',
  },
  primary: '#00205B',
  primaryOpacity: '#00205b',
  primaryOpacity15: '#b8cdf5',
  secondary: '#1e579b',
  textColorNav: '#FFFFFF',
  textColorHeaderTable: '#FFFFFF',
  textLoginVersion: '#FFFFFF',
  btnSuccess: '#00205B',
  textBtnSuccess: '#FFFFFF',
  textBtnHover: '#FFFFFF',
  backgroundSplashScreen: '#00205B',
  spinnerSplashScreen: '#FFFFFF',
  navBarColor: '#00205B',
  colorSidebarHeader: '#00153b',
  textColorSidebar: '#FFFFFF',
  enabledSettingsTabs: ['account', 'company', 'connections', 'linkedfarms'], // All enabled if empty
  enabledSettingsFeatures: ['linkedFarms.relatedCompanies', 'linkedFarms.relatedWithme'], // All enabled if empty
  apiBaseUrl: 'https://api-specialtyops.newholland.com/',
  dossierServiceUrl: 'https://viti-service-dev.xfarm.ag',
  SSOfrontAppCallback: 'https://specialtyops.newholland.com/#/oauthCheck?token=',
  googleApiKey: 'AIzaSyDkngDoX2cn5nqFis2zEBmt-I7yq17r0hM',
  stripePublicApiKey: 'pk_live_XrvLbzLTkQDB8jfNAE6Opssm007yvD4Pbl',
  launchDarklyKey: '69dcf8276edf1f0abcfdb2ae',
  assetsUrl: 'https://cdn.xfarm.ag/webapp/viti/',
  storewebAppUrl: 'https://vitipartnership.myplmconnect.com/sso/auth',
};
